import RouteConfig from './config/RouteConfig';
import ConfirmationView from 'text!./views/confirmation.html';
import ContactUsView from 'text!./views/contact-us.html';
import CompositeFlowConfig from 'integration/gateway/quoteandbind/config/CompositeFlowConfig';
import ActionMessageUtil from './util/ActionMessageUtil';
import 'edge/gateway/policyjob/app';
import 'edge/quoteandbind/app';
import _ from 'lodash';

export default angular.module('edge.gateway.quoteandbind.common.app', [
    'edge.quoteandbind.app',
    'edge.gateway.policyjob.app'
])

    .config(['$stateProvider', 'state_plugin_config', ($stateProvider, RootStateConfig) => {
        const states = new RouteConfig(RootStateConfig);
        for (const stateName in states) {
            if (states.hasOwnProperty(stateName)) {
                $stateProvider.state(stateName, states[stateName]);
            }
        }
    }])
    .factory('qnb.CompositeFlowDefn', CompositeFlowConfig)
    .factory('gateway.ActionMessageUtil', ActionMessageUtil)

    .value('qnb.doInitialAvailabilityCheck', false)

    .value('qnb.ViewModelCtx', {
        'AccountEmailRequired': false,
        'DriverEmailRequired': true,
        'AccountDOBRequired': false
    })

    .value('qnb.endpointConfig', {
        'loadSaveEndpoint': 'gatewayquote/quote',
        'emailEndpoint': 'gatewayquote/quote',
        'customQuoteEndpoint': 'gatewayquote/customquote',
        'bopCoverablesEndpoint': 'gatewayquote/bopcoverables',
        'cpCoverablesEndpoint': 'gatewayquote/cpcoverables',
        'wc7CoverablesEndpoint': 'gatewayquote/wc7coverables',
        'wc7CoveragesEndpoint': 'gatewayquote/wc7coverages'
    })

    .value('qnb.xCenterRouteConfig', 'pc')

    .value('qnb.spreadsheetProcessorConfig', {
        'downloadTemplateURL': 'document/gateway/spreadsheetprocessor',
        'uploadTemplateURL': 'gateway/spreadsheetprocessor'
    })

    .value('qnb.returnStateFn', model => ['quote.detail.summary', {
        submissionNumber: model.quoteID
    }])

    .value('qnb.effectiveDateStateFn', model => {
        switch (model.baseData.productCode.value) {
            case 'BusinessOwners':
                return ['effectiveDate-bop', {}];

            case 'CommercialProperty':
                return ['effectiveDate-cp', {}];

            case 'WC7WorkersComp':
                return ['wc7PolicyDetails', {}];

            default:
                return ['effectiveDate', {}];
        }
    })
    .value('qnb.errorStateFn', model => ['quote.detail.summary', {
        submissionNumber: model.quoteID.value
    }])

    // override base QnB configuration for agent portal
    .run(['$state', ($state) => {
        const qnbconfirmationState = $state.get('qnbconfirmation');
        const gatewayQNBconfirmationState = _.cloneDeep(qnbconfirmationState);
        gatewayQNBconfirmationState.template = ConfirmationView;
        $state.router.stateRegistry.deregister('qnbconfirmation');
        $state.router.stateRegistry.register(gatewayQNBconfirmationState);

        const contactUsState = $state.get('contactUs');
        const gatewayContactUsState = _.cloneDeep(contactUsState);
        gatewayContactUsState.template = ContactUsView;
        $state.router.stateRegistry.deregister('contactUs');
        $state.router.stateRegistry.register(gatewayContactUsState);
    }]);